(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-vouchers"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('MainContent');
  if (!root) return;
  const update = () => {
    root.querySelectorAll('.sc-template-giftcard').forEach(card => {
      const treatment = /treatment/i.test(card.querySelector('.sc-card__image img')?.alt || '');
      card.querySelectorAll('.sc-footer a').forEach(link => {
        if (link.textContent.trim() === 'Melanie Grant UK') link.textContent = 'Skincare Edit';
      });
      const action = card.querySelector('.sc-start-btn');
      if (treatment && action && action.textContent !== 'Contact the London team') {
        action.textContent = 'Contact the London team';
        action.href = 'mailto:london@melaniegrant.com';
      }
      const title = card.querySelector('h3');
      const heading = treatment ? 'Time for your skin.' : 'The gift of skin health.';
      if (title && title.textContent !== heading) title.textContent = heading;
      const how = card.querySelector('.sc-howto');
      if (how && !how.dataset.mgCopy) {
        const p = document.createElement('p');
        p.textContent = treatment ? 'Your treatment voucher is for Melanie Grant’s London studio. Contact our London team to arrange your visit, with your voucher details to hand.' : 'Explore Melanie’s edit of exceptional skincare. Choose your skincare, add it to your bag and enter your eGift Card code at checkout.';
        how.replaceChildren(p);
        how.dataset.mgCopy = 'true';
      }
    });
  };
  update();
  new MutationObserver(update).observe(root, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();
})();
